const userActionTypes = {
  FETCH_ALL_USERS: "FETCH_ALL_USERS",
  FETCH_ALL_USERS_SUCCESS: "FETCH_ALL_USERS_SUCCESS",
  FETCH_ALL_USERS_FAIL: "FETCH_ALL_USERS_FAIL",
};
export default userActionTypes;
